import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td
} from "@chakra-ui/react";

const ModalInvoicePreview = ({ isOpen, onClose, invoiceData, onConfirm }: any) => {
  if (!invoiceData) return null;
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl" isCentered>
      <ModalOverlay />
      <ModalContent borderRadius={15} p={8} maxW="90vw" minH="80vh">
        <ModalHeader fontSize="2xl" fontWeight="bold" letterSpacing={1} mb={2}>Invoice</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Box mb={2} color="gray.500" fontSize="md">Requestor Name:</Box>
          <Box fontWeight="bold" fontSize="xl" mb={1}>{invoiceData.requestorName}</Box>
          <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={2}>
            <Box>
              <Box fontSize="md" color="gray.600">Invoice ID</Box>
              <Box fontWeight="bold" fontSize="lg">{invoiceData.invoiceNumber || "-"}</Box>
            </Box>
            <Box textAlign="right">
              <Box fontSize="md" color="gray.600">Tanggal</Box>
              <Box fontWeight="bold" fontSize="lg">{invoiceData.invoiceDate || "-"}</Box>
            </Box>
          </Box>
          <Table mt={4} size="md" variant="simple" borderWidth={1} borderColor="#000" >
            <Thead>
              <Tr>
                <Th borderWidth={1} borderColor="#000" textAlign="center">No</Th>
                <Th borderWidth={1} borderColor="#000" textAlign="center">Keterangan</Th>
                <Th borderWidth={1} borderColor="#000" textAlign="center">Nominal</Th>
              </Tr>
            </Thead>
            <Tbody>
              <Tr>
                <Td borderWidth={1} borderColor="#000" textAlign="center">1</Td>
                <Td borderWidth={1} borderColor="#000">
                  {/* <Box fontWeight="bold">SIRE Inspection Update</Box>
                  <Box>Waktu tunggu: 2 hari</Box>
                  <Box color="gray.400">Lainnya <span style={{fontStyle:'italic',color:'#888'}}>Hotel</span></Box> */}
                  {"-"}
                </Td>
                <Td borderWidth={1} borderColor="#000" textAlign="right">
                  {/* Rp 92,284,500.00<br/>
                  Rp 20,134,800.00<br/>
                  Rp 1,500,000.76 */}
                  {"-"}
                </Td>
              </Tr>
              <Tr>
                <Td borderWidth={1} borderColor="#000" colSpan={2} textAlign="right">Sub Total</Td>
                <Td borderWidth={1} borderColor="#000" textAlign="right">{invoiceData.subtotal || "-"}</Td>
              </Tr>
              <Tr>
                <Td borderWidth={1} borderColor="#000" colSpan={2} textAlign="right">PPN (11%)</Td>
                <Td borderWidth={1} borderColor="#000" textAlign="right">{invoiceData.tax || "-"}</Td>
              </Tr>
              <Tr>
                <Td borderWidth={1} borderColor="#000" colSpan={2} textAlign="right" fontWeight="bold">TOTAL TAGIHAN</Td>
                <Td borderWidth={1} borderColor="#000" textAlign="right" fontWeight="bold">{invoiceData.totalCost || "-"}</Td>
              </Tr>
            </Tbody>
          </Table>
          {/* <Box mt={2} fontWeight="bold">Terbilang :</Box>
          <Box mb={2} fontSize="md">Seratus Dua Puluh Enam Juta Empat Ratus Lima Puluh Ribu Empat Ratus Dua Puluh Empat Rupiah</Box> */}

          {/* SIRE review details table at the bottom */}
          <Box mt={8} mb={2}>
            <strong>SIRE review details</strong>
            <Table mt={2} size="sm" variant="simple">
              <Thead>
                <Tr>
                  <Th>Order Number</Th>
                  <Th>Requestor</Th>
                  <Th>Vessel Name</Th>
                  <Th>IMO Number</Th>
                  <Th>Vessel Type</Th>
                  <Th>Review Date</Th>
                  <Th>ADD/ALD</Th>
                </Tr>
              </Thead>
              <Tbody>
                {invoiceData.details?.map((row: any, idx: number) => (
                  <Tr key={idx}>
                    <Td>{row.sequenceId}</Td>
                    <Td>{row.requestor}</Td>
                    <Td>{row.vesselName}</Td>
                    <Td>{row.imoNumber}</Td>
                    <Td>{row.vesselType}</Td>
                    <Td>{row.reviewDate}</Td>
                    <Td>{row.addAldPertamina}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </Box>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={onConfirm}>
            Confirm & Send
          </Button>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ModalInvoicePreview;
